export enum HacizGrupKoduEnum {
    Haciz = 0,
    Tebligat = 1,
    Genel = 2
}